import types from './types';

export interface OmniStoreEntity {
  queryId: string;
  name: string;
  canEdit: boolean;
  query: { [key: string]: string };
  ownerProfile: {
    firstName: string;
    lastName: string;
    [key: string]: any;
  };
}

export interface OmniStoreListState {
  data: OmniStoreEntity[];
  isFetching: boolean;
}

const omniStoreSegmentService = (
  state: OmniStoreListState = {
    data: [],
    isFetching: true
  },
  action: { type: string; entity: { data: any[] } }
) => {
  switch (action.type) {
    case types.START_FETCH:
      return {
        data: [],
        isFetching: true
      };

    case types.RECEIVE_OMNI_STORE_LIST_DATA:
      return {
        isFetching: false,
        data: action.entity.data
      };
    default:
      return state;
  }
};

export default omniStoreSegmentService;
